import { backToHome } from '@integration-frontends/integration/core/application';
import { push } from 'redux-first-history';
import { put, takeEvery } from 'redux-saga/effects';

const handler = function* () {
  yield put(push('/'));
};

export function* backToHomeEffects() {
  yield takeEvery(backToHome, handler);
}
